const TOPICMAPVERSION = '1.20.0-SNAPSHOT.1';
const TOPICMAPHASH = '#a2a33046c60545f83f3fc76d56da844028d80601';

export const getTopicMapVersion = () => {
	/*eslint-disable no-useless-concat*/
	if (TOPICMAPVERSION === '%TOPICMAP' + '_' + 'VERSION%') {
		return 'dev-hot-reload';
	} else {
		return TOPICMAPVERSION;
	}
};
export const getTopicMapHash = () => {
	if (TOPICMAPHASH === '%TOPICMAP' + '_' + 'HASH%') {
		return '#dev-hot-reload';
	} else {
		return TOPICMAPHASH;
	}
};
